const state = {
    suppliers: [
        // {
        //     title: '',
        // }
    ],
    users: [],
};

const mutations = {
    setSuppliers(state, value) {
        state.suppliers = value;
    },
    setUsers(state, value) {
        state.users = value;
    },
};

const actions = {
    fetchUsers({ commit }) {
        // Read from the database
        const users = [
            {
                'full_name': 'رسول مرشدی',
                'signature': 'https://fakeimg.pl/250x100',
            },
            {
                'full_name': 'سعید توفیق',
                'signature': 'https://fakeimg.pl/250x70',
            },
            {
                'full_name': 'علی غنجی',
                'signature': 'https://fakeimg.pl/250x50',
            }
        ]
        commit('setUsers', users)
    }
};

const getters = {
    suppliers: (state) => state.suppliers,
    users: (state) => state.users,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
